import React, { HTMLAttributes, useEffect, useState } from 'react';
import { useStore } from 'effector-react';
import { $task } from '../../../../store/states';
import Flex from '@components/Flex';
import { $authorizedUser, $permissions } from '@app/containers/store/states';
import { Button, Card, Intent } from '@blueprintjs/core';
import Heading from '@components/Heading';
import DevText from '@components/Text';
import { TaskState } from 'dy-frontend-http-repository/lib/data/enums';
import { useTaskStateTransition } from '@pages/Task/hooks';
import { TaskPermission } from 'dy-frontend-permissions/lib/permission';

export interface PublishedProps {
    isStateTransitionAllowed: boolean;
}

export type Props = HTMLAttributes<HTMLDivElement> & PublishedProps;

const Published: React.FC<Props> = (props) => {
    const permissions = useStore($permissions);
    const me = useStore($authorizedUser);
    const task = useStore($task);

    const { handleTransitionTaskState } = useTaskStateTransition();

    const [transitioningTo, setTransitionTo] = useState<TaskState | null>(null);

    const [isPickupReadyAllowed, setIsPickupReadyAllowed] = useState(false);

    useEffect(() => {
        if (!task || !me) {
            return;
        }
        setIsPickupReadyAllowed(
            permissions.isRoot.task
            || permissions.has(TaskPermission.STATE_TRANSITION_PICKUP_READY),
        );
    }, [task, permissions, me]);

    if (!me) {
        return null;
    }

    if (!task) {
        // Task is NOT fetched yet
        return null;
    }

    // TODO: Render helper action - assign participants if none assigned
    // TODO: Set deadline - if none assigned

    const handleTransitionToState = async (state: TaskState) => {
        try {
            setTransitionTo(state);
            const res = await handleTransitionTaskState(task.id, state);
        } catch (e) {
            // TODO: handle error
        } finally {
            setTransitionTo(null);
        }
    };

    const renderPickupReadyTransitionButton = () => {
        if (!props.isStateTransitionAllowed || !isPickupReadyAllowed) {
            return null;
        }

        return (
            <Button
                intent={Intent.PRIMARY}
                icon="pie-chart"
                disabled={transitioningTo !== null}
                loading={transitioningTo === TaskState.PICKUP_READY}
                onClick={() => handleTransitionToState(TaskState.PICKUP_READY)}
            >Ready for work</Button>
        );
    };

    return (
        <Card>
            <Flex align="center" justify="space-between" className="mb-1">
                <Heading type="h4" className="mb-1">To Design</Heading>
                <Flex>
                    <div>{renderPickupReadyTransitionButton()}</div>
                </Flex>
            </Flex>

            <DevText muted>
                Client successfully published request. Please review it, assign designers, and mark as ready for work.
            </DevText>
        </Card>
    );
};

export default Published;
